import { ArrowUpDown, MoreHorizontal, Pencil, Trash } from "lucide-react";
import { Button } from "../../components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";
import { DataTable } from "../../components/DataTable";
import { Badge } from "../../components/ui/badge";

const courses = [
  {
    id: "1",
    title: "Introduction to React",
    instructor: "John Doe",
    category: "Web Development",
    level: "Beginner",
    price: 49.99,
    students: 1234,
    rating: 4.5,
    status: "published",
  },
  {
    id: "2",
    title: "Advanced JavaScript Techniques",
    instructor: "Jane Smith",
    category: "Programming",
    level: "Advanced",
    price: 79.99,
    students: 876,
    rating: 4.8,
    status: "published",
  },
  {
    id: "3",
    title: "Data Science Fundamentals",
    instructor: "Alice Johnson",
    category: "Data Science",
    level: "Intermediate",
    price: 59.99,
    students: 2345,
    rating: 4.6,
    status: "published",
  },
  {
    id: "4",
    title: "UI/UX Design Principles",
    instructor: "Bob Wilson",
    category: "Design",
    level: "Beginner",
    price: 39.99,
    students: 987,
    rating: 4.3,
    status: "draft",
  },
  {
    id: "5",
    title: "Machine Learning with Python",
    instructor: "Eve Anderson",
    category: "Artificial Intelligence",
    level: "Advanced",
    price: 89.99,
    students: 1567,
    rating: 4.9,
    status: "published",
  },
];

const columns = [
  {
    accessorKey: "title",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Title
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
  },
  {
    accessorKey: "instructor",
    header: "Instructor",
  },
  {
    accessorKey: "category",
    header: "Category",
  },
  {
    accessorKey: "level",
    header: "Level",
  },
  {
    accessorKey: "price",
    header: "Price",
    cell: ({ row }) => {
      const price = Number.parseFloat(row.getValue("price"));
      const formatted = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(price);
      return <div className="font-medium">{formatted}</div>;
    },
  },
  {
    accessorKey: "students",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Students
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
  },
  {
    accessorKey: "rating",
    header: "Rating",
    cell: ({ row }) => {
      const rating = Number.parseFloat(row.getValue("rating"));
      return <div className="font-medium">{rating.toFixed(1)}</div>;
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const status = row.getValue("status");
      return (
        <Badge variant={status === "published" ? "default" : "secondary"}>
          {status}
        </Badge>
      );
    },
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const course = row.original;

      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => navigator.clipboard.writeText(course.id)}
            >
              Copy course ID
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <Pencil className="mr-2 h-4 w-4" />
              Edit course
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Trash className="mr-2 h-4 w-4" />
              Delete course
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
  },
];

export default function AdminCourses() {
  return (
    <div className="">
      <h1 className="text-3xl font-bold">Courses</h1>
      <DataTable columns={columns} data={courses} />
    </div>
  );
}
